import { render, staticRenderFns } from "./decade.vue?vue&type=template&id=39903ae3&scoped=true&"
import script from "./decade.vue?vue&type=script&lang=js&"
export * from "./decade.vue?vue&type=script&lang=js&"
import style0 from "./decade.vue?vue&type=style&index=0&id=39903ae3&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39903ae3",
  null
  
)

export default component.exports